"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AwardDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Dataset_1 = require("../Dataset");
class AwardDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.createAward));
        this.fund = (this.sendRequest(interfaces_1.WEN_FUNC.fundAward));
        this.rejec = (this.sendRequest(interfaces_1.WEN_FUNC.rejectAward));
        this.addOwner = (this.sendRequest(interfaces_1.WEN_FUNC.addOwnerAward));
        this.participate = (this.sendRequest(interfaces_1.WEN_FUNC.participateAward));
        this.approveParticipant = (this.sendRequest(interfaces_1.WEN_FUNC.approveParticipantAward));
        this.cancel = (this.sendRequest(interfaces_1.WEN_FUNC.cancelAward));
        this.getActiveLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'endDate', 'completed', 'approved'],
                fieldValue: [space, new Date().toISOString(), false, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getCompletedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'completed', 'approved'],
                fieldValue: [space, true, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getDraftLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'endDate', 'rejected', 'approved'],
                fieldValue: [space, new Date().toISOString(), false, false],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getRejectedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'rejected'],
                fieldValue: [space, false],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getLastActiveLive = (startAfter) => {
            const fieldName = ['endDate', 'completed', 'approved'];
            const fieldValue = [new Date().toISOString(), false, true];
            const operator = [interfaces_1.Opr.GREATER_OR_EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL];
            const orderBy = ['endDate'];
            const params = {
                dataset: this.dataset,
                fieldName,
                fieldValue,
                operator,
                startAfter,
                orderBy,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getTopByMemberLive = (member, completed, startAfter) => {
            const members = this.subset(interfaces_1.Subset.MEMBERS).getTopByMemberLive(member, completed, startAfter);
            return members.pipe((0, rxjs_1.switchMap)(async (members) => {
                const promises = members.map((member) => this.id(member.parentId).get());
                return (await Promise.all(promises)).map((s) => s);
            }));
        };
    }
}
exports.AwardDataset = AwardDataset;
